export default __webpack_public_path__ + "static/media/slider_5-sm@2x.969f23ad.jpg";